import { type Floor, type Gateway, type Multisensor, type Room } from "@eisox/api/core-api";
import type { ConfigType } from "@eisox/dayjs";
import type { BORDER_ROUTER_STATUS } from "@eisox/gateways";
import { getMultisensorProblem, type IMultisensor } from "@eisox/multisensors";

import type { EnhancedMultisensor } from "~/types/multisensor.type";

export const multisensorsToEnhancedMultisensors = (
  multisensors: Multisensor[],
  floors: Floor[],
  gateways: Gateway[],
  rooms: Room[],
  date: ConfigType,
): EnhancedMultisensor[] => {
  return multisensors.map(m => {
    const gateway = gateways.find(g => g.id === m.gatewayId);
    const room = rooms.find(r => r.id === m.roomId);
    const floor = floors.find(f => f.id === m.floor.id);

    if (!gateway) throw new Error(`Gateway ${m.gatewayId} not found for multisensor ${m.id}`);
    if (!room) throw new Error(`Room ${m.roomId} not found for multisensor ${m.id}`);
    if (!floor) throw new Error(`Floor ${m.floor.id} not found for multisensor ${m.id}`);

    const { errors, warnings, problemStatus } = getMultisensorProblem(
      m as unknown as IMultisensor,
      { ...gateway, borderRouterStatus: [gateway.borderRouterStatus as unknown as BORDER_ROUTER_STATUS] },
      date,
    );

    const { gatewayId: _, roomId: __, ...rest } = m;

    return {
      ...rest,
      floor: { x: m.floor.x, y: m.floor.y, id: floor.id, name: floor.name },
      gateway,
      room,
      errors,
      warnings,
      problemStatus,
    };
  });
};
